/* eslint-disable no-shadow */
/* eslint-disable object-curly-newline */
/* eslint-disable camelcase */
/* eslint-disable arrow-parens */
/* eslint-disable react/jsx-one-expression-per-line */
import React, { useRef, useEffect, useState } from 'react';
import { Form } from '@unform/web';
// import * as Yup from 'yup';
import { toast } from 'react-toastify';
import { MdModeEdit, MdDelete } from 'react-icons/md';

import Input from '~/components/Input';
import { Container, Header, Row, ButtonTest } from './styles';
import ImageInput from '../Modules/ImageInput';

import history from '~/services/history';
import api from '~/services/api';

export default function Cards() {
  const formRef = useRef(null);
  const [challenges, setChallenges] = useState([]);
  const [modules, setModules] = useState([]);
  const [module, setModule] = useState('');
  const [type, setType] = useState('');
  const [aceEditor, setAceEditor] = useState('');
  const [answer, setAnswer] = useState('');

  useEffect(() => {
    async function getData() {
      const { data } = await api.get('/challenges');
      setChallenges(data);
    }
    async function getDataModules() {
      const { data } = await api.get('/modules');
      setModules(data);
    }

    getData();
    getDataModules();
  }, []);

  async function handleSelectModule(e) {
    setModule(e.target.value);
  }

  async function handleSelectType(e) {
    setType(e.target.value);
  }

  async function handleSubmit(data) {
    try {
      const {
        title,
        question,
        description,
        link_question,
        position,
        language,
        help,
        file_id,
      } = data;

      if (module && title && question && type) {
        await api.post('/challenges', {
          title,
          question,
          description,
          link_question,
          module_id: module,
          position,
          type,
          language,
          help,
          ace_editor: aceEditor,
          file_id,
          answer,
        });
        // reset();
        return toast.success('Desafio cadastrado com sucesso');
      }
      return toast.error('Todos os campos sāo obrigatorios');
    } catch (error) {
      return toast.error('Erro ao cadastrar o desafio');
    }
  }

  async function handleDelete(id) {
    try {
      await api.delete(`/challenges/${id}`);
      return toast.success('Desafio deletado com sucesso');
    } catch (error) {
      return toast.error('Nāo foi possível deletar o desafio');
    }
  }

  return (
    <>
      <Header>
        <ButtonTest type="submit" onClick={() => history.push('/level')}>
          <h2>Level</h2>
        </ButtonTest>
        <ButtonTest type="submit" onClick={() => history.push('/subject')}>
          <h2>Subject</h2>
        </ButtonTest>

        <ButtonTest type="submit" onClick={() => history.push('/module')}>
          <h2>Modules</h2>
        </ButtonTest>

        {/* <ButtonTest type="submit" onClick={() => history.push('/card')}>
          <h2>Cards</h2>
        </ButtonTest> */}

        <ButtonTest
          selected
          type="submit"
          onClick={() => history.push('/challenge')}
        >
          <h2>Challenges</h2>
        </ButtonTest>

        <ButtonTest type="submit" onClick={() => history.push('/jobs')}>
          <h2>Jobs</h2>
        </ButtonTest>

        <ButtonTest type="submit" onClick={() => history.push('/file')}>
          <h2>Files</h2>
        </ButtonTest>

        <ButtonTest type="submit" onClick={() => history.push('/users')}>
          <h2>Users</h2>
        </ButtonTest>
      </Header>

      <Container>
        <h1>Cadastre Challenges:</h1>
        <Form ref={formRef} onSubmit={handleSubmit}>
          <div className="support">
            <div>
              <p style={{ fontSize: 20 }}>Escolha uma imagem:</p>
              <ImageInput name="file_id" />
            </div>

            <div className="select">
              <p>Selecione o Modulo do Challenge:</p>
              <select value={module} onChange={handleSelectModule}>
                {modules.map((module) => (
                  <option key={module.id} value={`${module.id}`}>
                    {module.title}
                  </option>
                ))}
              </select>
              <p>Selecione o Tipo de Questāo:</p>
              <select value={type} onChange={handleSelectType}>
                <option value="code">Código</option>
                <option value="theory">Teórico</option>
              </select>
              <Input
                name="language"
                type="text"
                placeholder="Linguagem de Programaçāo do Editor"
              />
              <textarea
                value={aceEditor}
                type="text"
                onChange={(event) => setAceEditor(event.target.value)}
                placeholder="Script Inicial no Editor"
              />
              <textarea
                value={answer}
                type="text"
                onChange={(event) => setAnswer(event.target.value)}
                placeholder="Resposta"
              />
            </div>

            <Input
              name="position"
              type="text"
              placeholder="Posiçāo no Modulo"
            />
            <Input name="title" type="text" placeholder="Titulo" />
            <Input name="question" type="text" placeholder="Pergunta" />
            <Input
              name="help"
              type="text"
              placeholder="Texto de Ajuda (se nāo deixar em branco)"
            />
            <Input
              name="description"
              type="text"
              placeholder="Codigo do Video do Youtube (se nāo deixar em branco)"
            />
            <Input
              name="link_question"
              type="text"
              placeholder="Site de referência (se nāo deixar em branco)"
            />
          </div>
          <button className="form" type="submit">
            CADASTRAR
          </button>
        </Form>
      </Container>

      <Container>
        <h1>Listagem de Challenges:</h1>
        {challenges.map((challenge) => (
          <Row key={challenge.id}>
            <div className="title">
              <h3>
                #{challenge.id}: {challenge.title}
              </h3>
            </div>
            <div className="description">
              <p>{challenge.question}</p>
            </div>
            <div className="button">
              <button
                type="submit"
                className="row"
                onClick={() => history.push(`/updatechallenge/${challenge.id}`)}
              >
                <MdModeEdit size={20} color="#090f35" />
              </button>
              <button
                type="submit"
                className="row"
                onClick={() => handleDelete(challenge.id)}
              >
                <MdDelete size={20} color="#FF0000" />
              </button>
            </div>
          </Row>
        ))}
      </Container>
    </>
  );
}
